import { IAHU } from '@/Core.Service.Domain/Controls/Controls.Common/types/index.ts';

import API from '@/Core.Service.Domain/Controls/AHUs/API/index.ts';
interface IContext {
  commit: (mutation: string, payload: IAHU) => void;
}

const setAHUEdit = async (context: IContext, ahu: IAHU) => {
  const response = await API.getAHUById(ahu.deviceId);
  context.commit('SET_AHU_EDIT', response);
};

export default {
  setAHUEdit,
};
